import { render, staticRenderFns } from "./ReportEditModal.vue?vue&type=template&id=23563d72&scoped=true"
import script from "./ReportEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportEditModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReportEditModal.vue?vue&type=style&index=0&id=23563d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23563d72",
  null
  
)

export default component.exports